// extracted by mini-css-extract-plugin
module.exports = {"toggle":"Toggle_toggle__WXJPT","options":"Toggle_options__qp_2e","hideInMobile":"Toggle_hideInMobile__ckom9"};